import React, { useContext } from "react";

import { Intro } from "components/commons";
import useDataTable from "hooks/useDataTable";
import locale from "localization";

import { mapApiRequest, mapDataToList, mapFilterToRequest } from "./voucher.mapper";
import { voucherCampaignFilterState } from "./campaign-voucher-filter.state";
import { columns } from "./campaign-vouchers-columns";

import DataTableV2 from "components/commons/data-table/data-table-v2";

import { SuccessModal } from "components/modals";
import useExport from "hooks/useExport";
import { generateReportAdmin } from "apis";
import { SessionContext } from "contexts";
import { useRouter } from "hooks";
import { Path } from "enums";
import CampaignVouchersFilter from "./campaign-voucher-filter";
import { getVouchersUniqueV2 } from "apis/voucher.api";
import { useLocation } from "react-router-dom";
import PanelButtons from "components/commons/panel-button/panel-buttons";

const CampaignVouchers = () => {
  const { sessionId } = useContext(SessionContext);
  const { history } = useRouter();
  const location = useLocation();

  const { filter, search, table } = useDataTable({
    api: { api: getVouchersUniqueV2, mapper: mapApiRequest },
    filter: { initialState: voucherCampaignFilterState({ location }), mapper: mapFilterToRequest },
    table: { key: "voucherClaims", mapper: (data) => mapDataToList({ history, data }), columns },
  });

  const exports = useExport({
    api: generateReportAdmin,
    hasModal: true,
    reportType: "voucher-claim",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      statuses: filter?.mappedFilterState?.status,
      voucherCampaignGroups: filter?.mappedFilterState?.campaignGroup,
      voucherCampaignCreators: filter?.mappedFilterState?.campaignCreators,
      voucherType:
        filter?.mappedFilterState?.voucherType === "all"
          ? ""
          : filter?.mappedFilterState?.voucherType,
      searchKey: search.searchKey,
      sessionId,
    },
  });

  return (
    <>
      <PanelButtons
        items={[
          {
            text: locale.uniqueVouchers,
            path: Path.CampaignVouchers,
          },
        ]}
      />
      <SuccessModal {...exports?.successModalComponent} />
      <div
        style={{
          marginTop: "30px",
        }}
      >
        <Intro
          title={locale.uniqueVouchers}
          subtitle={locale.viewAllUniqueVouchers}
          actionText={locale.createCampaignVouchers}
          actionOnClick={() => {
            history.push(Path.AddCampaignVouchers);
          }}
        />
      </div>
      <CampaignVouchersFilter {...filter} {...search} {...exports} />
      <DataTableV2 {...table} paginationV2={true} />
    </>
  );
};

export default CampaignVouchers;
